import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./AdminSidebar.css";

const AdminSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  let admin = { name: "Admin" };

  try {
    const stored = sessionStorage.getItem("currentUser");
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.role === "admin") {
        admin.name = parsed.username;
      }
    }
  } catch (e) {}

  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      <button
        className="admin-hamburger-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle admin sidebar"
      >
        ☰
      </button>

      {isOpen && (
        <div
          className="admin-sidebar-overlay"
          onClick={closeSidebar}
        ></div>
      )}

      <div className={`admin-sidebar ${isOpen ? "open" : ""}`}>

        <h3 className="admin-title">ADMIN</h3>

        <div className="admin-profile">
          <div className="avatar">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.029 10 8 10c-2.029 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
            </svg>
          </div>
          <p className="admin-name">{admin.name}</p>
        </div>

        <ul className="admin-menu">
          <li>
            <NavLink to="/admin/admin-dashboard" onClick={closeSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5v4.793l2.146 2.147a.5.5 0 0 1-.708.708L8 9.207V4.5A.5.5 0 0 1 8 4z"/>
                  <path d="M8 0a8 8 0 1 0 8 8A8 8 0 0 0 8 0zm0 1a7 7 0 1 1-7 7 7 7 0 0 1 7-7z"/>
                </svg>
              </span> Dashboard
            </NavLink>
          </li>
          
          <li>
            <NavLink to="/admin/complaint-control" onClick={closeSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z"/>
                  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3-.5a.5.5 0 0 1-.5-.5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h-2z"/>
                </svg>
              </span> Complaint Control
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/recycling-control" onClick={closeSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M5.5 0a.5.5 0 0 1 .5.5v1.293l.854-.853a.5.5 0 1 1 .707.707L6 3.207V3.5a.5.5 0 0 1-1 0V2.207l-.854.854a.5.5 0 0 1-.707-.707L4.5 1.793V.5a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v1.293l.854-.853a.5.5 0 0 1 .707.707L11 3.207V3.5a.5.5 0 0 1-1 0V2.207l-.854.854a.5.5 0 0 1-.707-.707L9.5 1.793V.5a.5.5 0 0 1 .5-.5zM3 6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3zm.5 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zM1 11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H1zm.5 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm13 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"/>
                </svg>
              </span> Recycling Control
            </NavLink>
          </li>

          <li>
            <NavLink to="/admin/generate-analytics" onClick={closeSidebar}>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"/>
                </svg>
              </span> Generate Analytics
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default AdminSidebar;
